module.exports = __webpack_public_path__ + "img/sign1.2b74955f.png";